import {
  getCookie,
  setCookie
} from '@/utils/cookie.js'
import env from '@/utils/env.js'

const ticketKey = 'ticket'
const tokenKey = 'token'
const uamTokenKey = 'uam_biz_token'
const rootDomain = env.getRootDomain()

export default {
  saveTicket(ticket) {
    setCookie(ticketKey, ticket, 7, '/', rootDomain)
    // localStorage && localStorage.setItem(ticketKey, ticket)
  },
  saveToken(token) {
    setCookie(tokenKey, token, 7, '/', rootDomain)
    setCookie(uamTokenKey, token, 7, '/', rootDomain)
    localStorage && localStorage.setItem(tokenKey, token)
    localStorage && localStorage.setItem(uamTokenKey, token)
  },
  removeTicket() {
    localStorage.removeItem(ticketKey)
    setCookie(ticketKey, '', -1, '/', rootDomain)
  },
  removeToken() {
    localStorage.removeItem(tokenKey)
    localStorage.removeItem(uamTokenKey)
    setCookie(tokenKey, '', -1, '/', rootDomain)
    setCookie(uamTokenKey, '', -1, '/', rootDomain)
  },
  getTicket() {
    return (localStorage && localStorage.getItem(ticketKey)) || getCookie(ticketKey)
  },
  getToken() {
    return (localStorage && localStorage.getItem(tokenKey)) || getCookie(tokenKey)
  }
}
